import { PageContainer } from '@components'
import { Contributors } from '@views/Contributors'
import { GetProjectsAchievementPayloadType } from '@api'
import { useRequestParams } from '@hooks'
import { store } from '@store'
import { useEffect } from 'react'

const ContributorsPage = () => {
  const projectsAchievementFiltered = store.use.projectsAchievementFiltered()
  const getProjectsAchievementAction = store.use.getProjectsAchievementAction().call
  const isLoadingGetProjectsAchievementAction =
    store.use.getProjectsAchievementAction().status === 'LOADING'

  const { afterPageChange, reqParams, pagination } =
    useRequestParams<GetProjectsAchievementPayloadType>()

  useEffect(() => {
    getProjectsAchievementAction(reqParams)
  }, [JSON.stringify(reqParams)])

  useEffect(() => {
    afterPageChange(projectsAchievementFiltered.length)
  }, [projectsAchievementFiltered.length])

  return (
    <PageContainer>
      <Contributors
        projectsAchievement={projectsAchievementFiltered}
        isLoading={isLoadingGetProjectsAchievementAction}
        tableProps={{ pagination }}
      />
    </PageContainer>
  )
}

export default ContributorsPage
